<script>
import { mapGetters } from 'vuex'
import { zendeskActions } from '@state/helpers'
import SubHeader from '@components/sub-header'

export default {
  name: 'ConfirmationQuestion',
  components: { SubHeader },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedOption: true,
      textareaContent: '',
    }
  },
  computed: {
    ...mapGetters('widgets', ['widgetProperty']),
  },
  watch: {
    textareaContent() {
      this.commitZendeskCommon({
        key: 'comment',
        data: {
          body: this.textareaContent,
        },
      })
    },
  },
  created() {},
  methods: {
    ...zendeskActions,
    setOption(option) {
      this.selectedOption = option
      if (option) {
        this.textareaContent = ''
      }
    },
  },
}
</script>

<template>
  <div
    v-if="widgetProperty('ConfirmationQuestion', 'show')"
    :class="$style.container"
  >
    <SubHeader :text="componentData.title"/>

    <div :class="$style.container__buttons">
      <BaseButton
        :seccondary="!selectedOption"
        @click="setOption(true)">{{ $t('COMMON.YES') }}</BaseButton>

      <BaseButton
        :seccondary="selectedOption"
        @click="setOption(false)">{{ $t('COMMON.NO') }}</BaseButton>
    </div>
    <div
      v-if="!selectedOption"
      :class="$style.textContainer"
    >
      <h4>{{ componentData.requestMoreInformation ? componentData.requestMoreInformation.title : componentData.textarea.title }}</h4>
      <BaseTextarea
        v-model="textareaContent"
        :placeholder="componentData.requestMoreInformation ? componentData.requestMoreInformation.placeholder : componentData.textarea.placeHolder"
        class-style="default"
        rows="2"
        name="textareaContent"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" module>
@import '@design';
.container {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 1rem;
  background-color: $white;

  h4 {
    @extend %typography-medium;

    margin: 0 0 1rem 0;
    font-weight: 600;
    color: $darker-gray;
    text-align: left;
  }

  &__buttons {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    width: 100%;

    @include responsive(phone) {
      width: 100%;
    }

    button {
      width: 40%;
      height: 3rem;
      border-radius: 8px;
    }
  }
}

.textContainer {
  width: 100%;
  margin: 1rem 0 1rem 0;
}
</style>
